import { defineStore } from "pinia";
import { authentication, createDirectus, rest } from "@directus/sdk";
import DirectusCollectionsInterface from "../interfaces/DirectusCollectionsInterface";
import { ref, watch } from "vue";
import qs from "qs";
import { useCityStore } from "@/modules/city/store/city";
import CityInterface from "@/modules/city/interfaces/CityInterface";
import { useCachedFetch } from "@/composables/useCachedFetch";
class LocalStorage {
  protected key: string;
  constructor(prefix: string) {
    this.key = `${prefix}_direcuts_auth`;
  }
  get() {
    return localStorage.getItem(this.key)
      ? JSON.parse(localStorage.getItem(this.key) as string)
      : undefined;
  }
  set(data: any) {
    localStorage.setItem(this.key, JSON.stringify(data));
  }
}

export const useDirectusStore = defineStore("directus", () => {
  const storages = ref<Record<string, LocalStorage>>({});

  storages.value.main = new LocalStorage("main");

  const main = ref(
    createDirectus<DirectusCollectionsInterface>(
      process.env.VUE_APP_API_BASE_URL as string,
      { globals: { fetch: useCachedFetch().fetch } }
    )
      .with(
        authentication("json", {
          storage: storages.value.main,
        })
      )
      .with(rest())
  );
  const cityStore = useCityStore();

  const city = ref<typeof main | null>(null);

  watch(
    () => cityStore.city,
    (newCity: CityInterface | null) => {
      if (newCity) {
        storages.value[newCity.id] = new LocalStorage(newCity.id);
        city.value = createDirectus<DirectusCollectionsInterface>(
          newCity.api_url,
          {
            globals: { fetch: useCachedFetch().fetch },
          }
        )
          .with(
            authentication("json", {
              storage: storages.value[newCity.id],
            })
          )
          .with(rest());

        useCachedFetch().precache();
      } else {
        city.value = null;
      }
    }
  );

  const getAssetUrl = (
    id: string,
    client: "main" | "city",
    query: any = {}
  ) => {
    const assetsBaseURL =
      client === "city" && city.value
        ? city.value.url.origin
        : main.value.url.origin;
    return `${assetsBaseURL}/assets/${id}${qs.stringify(query)}`;
  };

  //   const main = new Directus<DirectusCollectionsInterface>(
  //     process.env.VUE_APP_API_BASE_URL as string,
  //     {
  //       auth: {
  //         mode: "json",
  //       },
  //       storage: {
  //         prefix: "mainClient",
  //         mode: "LocalStorage",
  //       },
  //     }
  //   );

  return {
    main,
    city,
    getAssetUrl,
    storages,
  };
});
